import { useNavigate } from 'react-router-dom';
import type { VaultItem } from '@heybesafe/shared';
import { HbsListRow } from './hbs/ListRow';
import { Icon } from './hbs/Icon';
import { ContactAvatar } from './ContactAvatar';

/**
 * One shared-contact row in the Family overview's Contacts pane. Mirrors the
 * personal `ContactRow` (avatar + name + supporting detail) and routes View to
 * the read-only shared-contact detail (`FamilyContactDetailPage`) — through the
 * contact's category when filed, else the Family-contacts catch-all. Supporting
 * line prefers the contact's first phone/email — the info most useful at a glance.
 */
export function FamilyContactRow({ item }: { item: VaultItem }): JSX.Element {
  const navigate = useNavigate();
  const firstPhone = item.phones?.find((p) => p.value.trim())?.value;
  const firstEmail = item.emails?.find((e) => e.value.trim())?.value;
  const supporting = [firstPhone, firstEmail].filter(Boolean).join(' · ')
    || item.role || item.company || '';
  const detailPath = item.categoryId
    ? `/orgs/${item.orgId}/binder/${item.categoryId}/contacts/${item.id}`
    : `/orgs/${item.orgId}/binder/contacts/${item.id}`;

  return (
    <HbsListRow
      id={`family-contact-row-${item.id}`}
      leading={<ContactAvatar name={item.name} size={34} />}
      title={item.name}
      supporting={supporting}
      onClick={() => navigate(detailPath)}
      actions={
        <button
          id={`family-contact-view-${item.id}`}
          type="button"
          aria-label="View"
          onClick={(e) => {
            e.stopPropagation();
            navigate(detailPath);
          }}
          className="p-1.5 rounded-hbs-sm text-hbs-text-mute hover:text-hbs-text hover:bg-hbs-surface-alt"
        >
          <Icon name="view" size={14} />
        </button>
      }
    />
  );
}
